(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadOffer', LeadOffer);

    LeadOffer.$inject = ['$resource', 'DateUtils'];

    function LeadOffer ($resource, DateUtils) {
        var resourceUrl =  'api/lead-offers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.firstEstimationDate = DateUtils.convertDateTimeFromServer(data.firstEstimationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
